export default __webpack_public_path__ + "static/media/friends.d9a12254.svg";